import React from 'react';
import Link from '@amzn/awsui-components-console/link';
import {
  CUT_TICKET_URL,
  SLACK_CHANNEL_URL,
  USER_GUIDE_URL,
} from 'src/common/constants';
import styles from './FooterBar.module.scss';
import { useTranslation } from 'src/i18n/shim/useTranslation';

/**
 * Shared footer bar rendered at the bottom of every page.
 * Displays navigation links, branding, and copyright.
 */
const FooterBar: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.barWrapper}>
      <div className={styles.bar}>
        <span className={styles.links}>
          <Link
            href={USER_GUIDE_URL}
            external={true}
            color="inverted"
            fontSize="body-s"
          >
            {t('footer-wiki')}
          </Link>
          <Link
            href={SLACK_CHANNEL_URL}
            external={true}
            color="inverted"
            fontSize="body-s"
          >
            {t('footer-slack')}
          </Link>
          <Link
            href={CUT_TICKET_URL}
            external={true}
            color="inverted"
            fontSize="body-s"
          >
            {t('footer-ticket')}
          </Link>
        </span>
        <span className={styles.branding}>{t('footer-branding')}</span>
        <span className={styles.copyright}>{t('footer-copyright')}</span>
      </div>
    </div>
  );
};

export default FooterBar;
